import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Image, Col, Form, Row, Button } from "react-bootstrap";
import { TextField, FormControl, Select } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Toggle } from "../../../superAdminReusable/reusableSuperAdminButton/Toggle";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
//import { AmealioLoader } from "../../../Loader/AmealioLoader";
import moment from "moment";
import axios from "axios";
import {
  serverApi,
  videoUploadSize,
  imageUploadSize,
} from "../../../../../config/Keys";
import Alert from "react-s-alert";
import Switch from "react-switch";
import isEmpty from "../../../../../store/validation/is-Empty";
import SimpleReactLightbox from "simple-react-lightbox";
import MultipleImageUploadComponent from "../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import AlertDialogProgress from "../../../../reusableComponents/allPopupReusable/DialogProgression";
import { update_admin_event } from "../../../../../store/actions/SuperAdminActions/commonSuperAdmin";

const validationSchema = yup.object({
  name: yup
    .string()
    .required("Event name is required")
    .min(1, "Minimum 1 Character")
    .max(64, "Maximum 64 Character"),
  description: yup
    .string()
    .required("Description is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
  start_date: yup.string().required("Start date is required"),
  start_time: yup.string().required("Start time is required"),
  end_date: yup.string().required("End date is required"),
  end_time: yup.string().required("End time is required"),
  eventLink: yup
    .string()
    .matches(
      /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      "Url is invalid"
    )
    .required("Please enter url"),

  terms_and_condition: yup
    .string()
    .required("Terms and condtion  is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
});

const EditOnlineEvent = (props) => {
  //state
  let history = useHistory();
  const [loading, setLoading] = useState();
  const [checked, setChecked] = useState(false);
  const [file, setFile] = useState(null);
  const [Video, setVideo] = useState(null);
  const [primaryOffer, setPrimaryOffer] = useState({ primaryOffer: false });
  const [active, setactive] = useState({ active: false });
  const markAsPrimary = (data) => (e) => {
    // setPrimaryOffer({ primaryOffer: !primaryOffer.primaryOffer });
    if (data === false) {
      setPrimaryOffer({ primaryOffer: true });
      setactive({ active: true });
    } else {
      setPrimaryOffer({ primaryOffer: !primaryOffer.primaryOffer });
    }
  };
  const statusChange = (e) => {
    setactive({ active: !active.active });
  };

  const [state, setState] = useState({
    minAge: 18,
    restaurant_pictures: [],
    restaurant_pictures_new: [],
    restaurant_video: [],
    video_url: "",
    actionButton: false,
    progress: 0,
  });
  const selecthandleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };
  const toggleFunction = (e) => {
    setChecked({ checked: !checked.checked });
  };

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/

  const onCompleteUploadMultipleCrop = (e) => {
    let oldData = state.restaurant_pictures;
    oldData.push(e);
    setState({
      ...state,
      restaurant_pictures: oldData,
      actionButton: true,
    });
  };

  const uploadMultipleFiles = (e) => {
    // setState({ multipleImageLoader: true });
    const vendor_id = editData.vendor_id;
    const restaurant_name = editData.restaurant_id.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    var newUploaded = [];
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > imageUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else if (e.target.files.length > 10) {
        alert("You can upload only 10 files");
        return (flag = false);
      } else {
        let allPicures = state.restaurant_pictures;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            // flag = true;
            return (flag = true);
          } else {
            return (flag = false);
          }
        });
        if (!flag) {
          newUploaded.push(e.target.files[i]);
          data.append("files", e.target.files[i]);
        }
      }
    }
    if (!flag) {
      setState({
        ...state,
        restaurant_pictures_new: newUploaded,
        combined: combined,
      });
    } else {
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    e.target.value = "";
  };

  const multipleResetFile = (indexId) => {
    let allPicures = state.restaurant_pictures;
    let allPicuresObj = allPicures.find((images, index) => index === indexId);
    if (allPicuresObj === 0 || allPicuresObj) {
      allPicures.splice(allPicures.indexOf(allPicuresObj), 1);
      setState({ ...state, allPicures: allPicures, actionButton: true });
    }
  };

  /*************************************
   * @DESC Multiple Video Upload
   ************************************/
  const uploadMultipleVideoFiles = (e) => {
    e.preventDefault();
    // setState({ multipleImageLoader: true });
    const vendor_id = editData.vendor_id;
    const restaurant_name = editData.restaurant_id.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > videoUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else {
        if (state.restaurant_video && state.restaurant_video.length > 0) {
          if (state.restaurant_video[0].name === e.target.files[i].name) {
            return (flag = true);
          }
        }
        if (!flag) {
          data.append("file", e.target.files[i]);
        }
      }
    }
    // ?uploadSide=${combined}
    var newData = e.target.files;
    if (!flag) {
      const setProgress = (percent) => {
        setState({ ...state, progress: percent });
      };
      axios
        .post(`${serverApi}/upload-assets-video`, data, {
          onUploadProgress: (progressEvent) => {
            setProgress((progressEvent.loaded / progressEvent.total) * 100);
          },
        })
        .then((res) => {
          setState({
            ...state,
            restaurant_video: newData,
            // multipleImageLoader: false,
            video_url: res.data,
            actionButton: true,
          });
          Alert.success(`<h4>Restaurant Video Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          // setState({ multipleImageLoader: false });
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      // setState({ multipleImageLoader: false });
      Alert.error(`<h4>Can not upload the same video</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  const multipleVideoResetFile = (e) => {
    let video_url = state.video_url;
    let restaurant_video = state.restaurant_video;
    video_url = "";
    restaurant_video = [];
    setState({
      ...state,
      restaurant_video: restaurant_video,
      video_url: video_url,
      actionButton: true,
    });
  };

  const singleEventData = useSelector((state) => {
    return !isEmpty(state.commonSuperAdmin)
      ? state.commonSuperAdmin.admin_event_details
      : "";
  });

  useEffect(() => {
    if (singleEventData) {
      setEditData(singleEventData);
    }
  }, [singleEventData]);

  useEffect(() => {
    console.log(history.location && history.location.state);
    if (history.location && history.location.state) {
      setEditData(history.location.state.admin_event_details);
    }
  }, [history.location && history.location.state]);

  const [editData, setEditData] = useState(singleEventData);

  useEffect(() => {
    if (editData.name) {
      formik.setFieldValue("name", editData.name);
    }
    if (editData.description) {
      formik.setFieldValue("description", editData.description);
    }
    if (editData.coupon_code) {
      formik.setFieldValue("coupon_code", editData.coupon_code);
    }
    if (editData.terms_and_condition) {
      formik.setFieldValue("terms_and_condition", editData.terms_and_condition);
    }
    if (editData.videos && editData.photos && editData._id) {
      setState({
        ...state,
        restaurant_pictures: !isEmpty(editData.photos) ? editData.photos : [],
        video_url: !isEmpty(editData.videos) ? editData.videos : "",
      });
    }
    if (editData.mark_as_primary) {
      setPrimaryOffer({ primaryOffer: editData.mark_as_primary });
    }
    if (editData.active) {
      setactive({ active: editData.active });
    }
    if (editData.start_date) {
      let startD = editData.start_date.split("T")[0];
      formik.setFieldValue(`start_date`, startD);
      let startT = moment(editData.start_date).format("HH:mm");
      formik.setFieldValue(`start_time`, startT);
    }
    if (editData.end_date) {
      let endD = editData.end_date.split("T")[0];
      formik.setFieldValue(`end_date`, endD);
      let endT = moment(editData.end_date).format("HH:mm");
      formik.setFieldValue(`end_time`, endT);
    }
    if (editData.eventLink) {
      formik.setFieldValue("eventLink", editData.eventLink);
    }
    if (editData.eventPassword) {
      formik.setFieldValue("eventPassword", editData.eventPassword);
    }
  }, [editData]);

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      mark_as_primary: false,
      active: false,
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      isKidsAllowed: false,
      minAge: 18,
      //vendor_id: "5f8ac1f8c0aac52d42af60a8",
      isOnline: true,
      eventLink: "",
      eventPassword: "",
      photos: [],
      videos: [],
      terms_and_condition: "",
    },
    validationSchema,

    onSubmit: (values) => {
      const startDate = {
        start_date: moment(
          values.start_date + "T" + values.start_time
        ).valueOf(),
      };
      const end_Date = {
        end_date: moment(values.end_date + "T" + values.end_time).valueOf(),
      };

      values.start = startDate.start_date;
      values.end = end_Date.end_date;
      values.vendor_id = props.auth.user.VendorUser._id;

      if (checked.checked) {
        values.isKidsAllowed = true;
        values.minAge = state.minAge;
      }

      if (primaryOffer.primaryOffer) {
        values.mark_as_primary = true;
      }
      if (active.active) {
        values.active = true;
      }

      const token = !isEmpty(props.auth.user.accessToken)
        ? props.auth.user.accessToken
        : "";
      const eventId = editData._id;
      const formData = {
        name: values.name,
        description: values.description,
        mark_as_primary: values.mark_as_primary,
        start_date: values.start,
        end_date: values.end,
        photos: state.restaurant_pictures,
        terms_and_condition: values.terms_and_condition,
        active: values.active,
        venue_address: "",
        vendor_id: values.vendor_id,
        isOnline: true,
        isKidsAllowed: values.isKidsAllowed,
        minAge: values.minAge,
        eventLink: values.eventLink,
        eventPassword: values.eventPassword,
        videos: state.video_url,
        point_of_entry: "VENDOR",
      };
      props.update_admin_event(token, formData, eventId, onEventSuccess);
    },
  });

  const onEventSuccess = (e) => {
    Alert.success("<h4>Event Update Successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/superadminrestaurantevents");
  };

  const [minDate, setMinDate] = useState("");
  const [minEndDate, setMinEndDate] = useState("");
  const handleStartDateChange = (e) => {
    formik.setFieldValue("start_date", e.target.value);
    formik.setFieldValue("end_date", "");
    setMinEndDate(e.target.value);
  };
  useEffect(() => {
    let data = moment().format("YYYY-MM-DD");
    setMinDate(data);
  }, []);

  const [count, setCount] = useState(1);
  const onClickSave = (e) => {
    // e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  // useEffect(() => {
  //   formik.setFieldValue("name", "");
  // }, []);

  useEffect(() => {
    if (formik.errors && formik.errors.name) {
      let nameElement = document.getElementById("name");
      nameElement.focus();
    } else if (formik.errors && formik.errors.description) {
      let descElement = document.getElementById("description");
      descElement.focus();
    } else if (formik.errors && formik.errors.start_date) {
      let startDateElement = document.getElementById("start_date");
      startDateElement.focus();
    } else if (formik.errors && formik.errors.start_time) {
      let startTimeElement = document.getElementById("start_time");
      startTimeElement.focus();
    } else if (formik.errors && formik.errors.end_time) {
      let endDateElement = document.getElementById("end_time");
      endDateElement.focus();
    } else if (formik.errors && formik.errors.end_date) {
      let endTimeElement = document.getElementById("end_date");
      endTimeElement.focus();
    } else if (formik.errors && formik.errors.eventLink) {
      let eventLinkElement = document.getElementById("eventLink");
      eventLinkElement.focus();
    } else if (formik.errors && formik.errors.terms_and_condition) {
      let termAndCondtionsElement = document.getElementById(
        "terms_and_condition"
      );
      termAndCondtionsElement.focus();
    }
  }, [count]);

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Edit Event</div>
              </div>
              <div className="d-flex">
                <div className="enIMG75">
                  <Image
                    src={editData?.restaurant_id?.logo_url}
                    alt={editData?.restaurant_id?.restaurant_name}
                    title={editData?.restaurant_id?.restaurant_name}
                    fluid
                    className="w-100 h-100"
                  />
                </div>
                <div className="pl-3 row">
                  <Col
                    lg={10}
                    xl={8}
                    className="d-flex flex-column justify-content-between"
                  >
                    <div className="f24-500">
                      {editData?.restaurant_id?.restaurant_name}
                    </div>
                    <div className="f14-400">
                      {editData?.restaurant_id?.restaurant_address}
                    </div>
                  </Col>
                </div>
              </div>
              <hr />
              <div className="d-flex align-items-start">
                <div className={`enAddOffersOPtion `}>
                  <Image
                    src={require("../../../../../assets/images/UserManagement/onlineActiveOffer.svg")}
                    alt="View"
                    title="View"
                    fluid
                    className="ml-3"
                  />
                  <span className="text-red f12-400 d-block w-100 mb-2">
                    Online Event
                  </span>
                  <span className="w-100 f9-400 d-block">
                    (Note: these offers can be only be used in your business
                    location offline)
                  </span>
                </div>
              </div>
              <hr />
              <Form>
                <Row className="pt-4">
                  <Col lg={8}>
                    <Form.Group>
                      <TextField
                        id="name"
                        label="Event Name"
                        type="text"
                        variant="outlined"
                        className={`w-100 ${
                          formik.errors.name && formik.touched.name
                            ? "enError"
                            : ""
                        }`}
                        name="name"
                        onChange={formik.handleChange}
                        value={formik.values.name}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.name && formik.touched.name ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.name}
                        </div>
                      ) : null}
                    </Form.Group>
                    <Form.Group>
                      <TextField
                        id="description"
                        label="Description"
                        type="text"
                        multiline
                        rows="5"
                        variant="outlined"
                        className={`w-100 ${
                          formik.errors.description &&
                          formik.touched.description
                            ? "enError"
                            : ""
                        }`}
                        name="description"
                        onChange={formik.handleChange}
                        value={formik.values.description}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.description &&
                      formik.touched.description ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.description}
                        </div>
                      ) : null}
                    </Form.Group>
                    <Row className="pb-4">
                      <Col lg={6}>
                        <div className="f12-400">
                          (Fill out the details, event are used offline)
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="d-flex align-items-start">
                          <Switch
                            onChange={markAsPrimary}
                            checked={primaryOffer.primaryOffer}
                            offColor="#EEEEEE"
                            onColor="#EEEEEE"
                            offHandleColor="#212121"
                            onHandleColor="#59F832"
                            handleDiameter={24}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={15}
                            width={41}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                            id="material-switch"
                          />
                          <div className="pl-2">
                            <div className="f12-500 mb-2">
                              Make this Event Primary
                            </div>
                            <div className="f10-400">
                              (Note you can make only one Offer primary, by
                              making this offer primary it will remove primary
                              from other active offers)
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={12}>
                    <hr />

                    <div className="f16-500 py-1">Allow Kids?</div>
                    <div className="f10-400 pb-4">
                      (This may be relevant if you are a Bar and Night Club with
                      min age to enter, you may still have to check the ID for
                      the entrants)
                    </div>
                    <Row className="align-items-center pb-3">
                      <Col md={3}>
                        <div className="f14-400 text-dark">Kids Allowed</div>
                      </Col>
                      <Col md={9}>
                        <div className="d-flex align-items-center">
                          <div className="f12-400 mr-2">No</div>
                          <Toggle
                            checked={checked.checked}
                            toggleFunction={toggleFunction}
                          />
                          <div className="f12-400 ml-2">Yes</div>
                        </div>
                      </Col>
                    </Row>
                    {checked.checked ? (
                      <Row className="align-items-center pb-3">
                        <Col md={3}>
                          <div className="f14-400 text-dark">
                            Min Age for Entry
                          </div>
                        </Col>
                        <Col md={9}>
                          <FormControl variant="outlined" className={"w134"}>
                            <Select
                              value={state.minAge}
                              onChange={selecthandleChange}
                              inputProps={{
                                name: "minAge",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <option value={"18"}>18</option>
                              <option value={"21"}>21</option>
                            </Select>
                          </FormControl>
                        </Col>
                      </Row>
                    ) : (
                      <></>
                    )}
                    <hr className="mb-5" />
                    <Row className="pb-4 align-items-center">
                      <Col md={3} xl={2}>
                        <TextField
                          id="start_date"
                          label="Start Date"
                          variant="outlined"
                          InputProps={{
                            inputProps: { min: minDate },
                          }}
                          type="date"
                          defaultValue={minDate}
                          className={`w-100 ${
                            formik.errors.start_date &&
                            formik.touched.start_date
                              ? "enError"
                              : ""
                          }`}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="start_date"
                          onChange={(e) => handleStartDateChange(e)}
                          //onChange={formik.handleChange}
                          value={formik.values.start_date}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.start_date &&
                        formik.touched.start_date ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.start_date}
                          </div>
                        ) : null}
                      </Col>
                      <Col md={3} xl={2}>
                        <TextField
                          id="start_time"
                          label="Start Time"
                          variant="outlined"
                          type="time"
                          className={`w-100 ${
                            formik.errors.start_time &&
                            formik.touched.start_time
                              ? "enError"
                              : ""
                          }`}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="start_time"
                          onChange={formik.handleChange}
                          value={formik.values.start_time}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.start_time &&
                        formik.touched.start_time ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.start_time}
                          </div>
                        ) : null}
                      </Col>
                      <Col md={3} xl={2}>
                        <TextField
                          id="end_date"
                          label="End Date"
                          variant="outlined"
                          InputProps={{
                            inputProps: { min: minEndDate },
                          }}
                          type="date"
                          className={`w-100 ${
                            formik.errors.end_date && formik.touched.end_date
                              ? "enError"
                              : ""
                          }`}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="end_date"
                          onChange={formik.handleChange}
                          value={formik.values.end_date}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.end_date && formik.touched.end_date ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.end_date}
                          </div>
                        ) : null}
                      </Col>
                      <Col md={3} xl={2}>
                        <TextField
                          id="end_time"
                          label="End Time"
                          variant="outlined"
                          type="time"
                          className={`w-100 ${
                            formik.errors.end_time && formik.touched.end_time
                              ? "enError"
                              : ""
                          }`}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="end_time"
                          onChange={formik.handleChange}
                          value={formik.values.end_time}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.end_time && formik.touched.end_time ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.end_time}
                          </div>
                        ) : null}
                      </Col>
                    </Row>
                    {/* <Row className="pb-4 align-items-center">
              <Col md={4} lg={4}>
                <Form.Group>
                  <TextField
                    label="Coupon Code"
                    type="text"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
            </Row> */}
                    <Row>
                      <Col lg={8} className="pb-4">
                        <Form.Group>
                          <TextField
                            id="eventLink"
                            label="Hyperlink"
                            type="text"
                            variant="outlined"
                            className={`w-100 ${
                              formik.errors.eventLink &&
                              formik.touched.eventLink
                                ? "enError"
                                : ""
                            }`}
                            name="eventLink"
                            onChange={formik.handleChange}
                            value={formik.values.eventLink}
                            onBlur={formik.handleBlur}
                          />
                          {formik.errors.eventLink &&
                          formik.touched.eventLink ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.eventLink}
                            </div>
                          ) : null}
                        </Form.Group>
                      </Col>
                      <Col lg={8} className="pb-4">
                        <Form.Group>
                          <TextField
                            label="Password(if any)"
                            type="text"
                            variant="outlined"
                            className="w-100"
                            name="eventPassword"
                            onChange={formik.handleChange}
                            value={formik.values.eventPassword}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <hr />
                    <div className="event-offer-image">
                      <SimpleReactLightbox>
                        <MultipleImageUploadComponent
                          title="Add Photos*"
                          smallTitle="(Add detail pictures of Business Establishment Images - If needed you can get a professional photo shoot to make it attractive this will appear on user app this will be reviewed periodically )"
                          onChange={uploadMultipleFiles}
                          stateValue={
                            state.restaurant_pictures &&
                            state.restaurant_pictures
                          }
                          newUploaded={
                            state.restaurant_pictures_new
                              ? state.restaurant_pictures_new
                              : []
                          }
                          combined={state.combined}
                          onCompleteUploadMultipleCrop={
                            onCompleteUploadMultipleCrop
                          }
                          removeImage={multipleResetFile}
                          accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                          // loader={state.multipleImageLoader}
                        />
                        <div className="font_12_r c_gray mb-4 d-flex">
                          (You can add upto 6-10 pictures)
                          {/* <div className="c_red ml-2"> Learn more</div> */}
                        </div>
                      </SimpleReactLightbox>
                    </div>
                    <div className="event-offer-image">
                      <SimpleReactLightbox>
                        <MultipleImageUploadComponent
                          title="Add Video"
                          smallTitle="( Add Videos or 360 view of Business Establishment - If needed you can get a professional photo shoot or video to make it attractive - this will appear on user app)"
                          onChange={uploadMultipleVideoFiles}
                          stateValue={
                            state.video_url === "" ? [] : [state.video_url]
                          }
                          removeImage={multipleVideoResetFile}
                          accept="video/*"
                          singleUpload={true}
                          videoUpload={true}
                          // loader={state.multipleImageLoader}
                        />
                        <div className="font_12_r c_gray mb-4 d-flex">
                          (You can add upto 6 videos){" "}
                          <div className="c_red ml-2">Learn more</div>
                        </div>
                      </SimpleReactLightbox>
                      {!state.progress && state.progress === 0 ? null : (
                        <AlertDialogProgress
                          progress={state.progress}
                          title="Video Uploading..."
                        />
                      )}
                    </div>
                    <Row>
                      <Col lg={8}>
                        <Form.Group>
                          <TextField
                            id="terms_and_condition"
                            label="Terms and Conditions"
                            type="text"
                            multiline
                            rows="5"
                            variant="outlined"
                            className={`w-100 ${
                              formik.errors.terms_and_condition &&
                              formik.touched.terms_and_condition
                                ? "enError"
                                : ""
                            }`}
                            name="terms_and_condition"
                            onChange={formik.handleChange}
                            value={formik.values.terms_and_condition}
                            onBlur={formik.handleBlur}
                          />
                          {formik.errors.terms_and_condition &&
                          formik.touched.terms_and_condition ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.terms_and_condition}
                            </div>
                          ) : null}
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="py-4 d-flex align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5 btn150px"
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5 btn150px"
                        onClick={() => onClickSave()}
                      >
                        Save
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

EditOnlineEvent.propTypes = {
  auth: PropTypes.object.isRequired,
  update_admin_event: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { update_admin_event })(
  EditOnlineEvent
);
